import React, { useContext } from "react";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { Spinner } from "lib/components";
import constant from "lib/constant/constant";

import { AdminBulkProductEdit } from "./admin/features";
import { OperatorBulkProductEdit } from "./operator/features";
import { ProviderBulkProductEdit } from "./provider/features";

const { userKey } = constant;
const { operator, provider, admin } = userKey;

const BulkProductEdit = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (role === admin) {
      return <AdminBulkProductEdit />;
    }
    if (role === operator) {
      return <OperatorBulkProductEdit />;
    }
    if (role === provider) {
      return <ProviderBulkProductEdit />;
    }
    return null;
  };

  if (isLoading) {
    return <Spinner />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const BulkProductEditComponent = getComponent(currentUserRole);
  return BulkProductEditComponent;
};

export default BulkProductEdit;
